/* eslint-disable @typescript-eslint/no-explicit-any */
// SlideShow.js
import React, { useState } from 'react';
import styled from 'styled-components';
import images from '../../Theming/images';
import { MultiStepProps } from '../PartnerPluginActivateMultiStep';
import colors from '../../Theming/colors';

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const Slides = styled.div<{ activeIndex: number }>`
  display: flex;
  transition: transform 0.3s;
  transform: translateX(${(props) => -props.activeIndex * 100}%);
`;

const Slide = styled.div`
  min-width: 100%;
  min-height: 230px;
`;

const PillsContainer = styled.div`
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 5px;
`;

const Pill = styled.div<{ active: boolean; sliide?: boolean }>`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  cursor: pointer;

  ${(props) =>
    props.sliide
      ? `
      background-color: ${props.active ? colors.grey : colors.verizonRed};
  `
      : `
  background-color: ${props.active ? colors.grey : colors.greyWhite};
  `}
`;

const StyledImage = styled.img`
  width: 320px;
`;

const BeSureToAllowSlide: React.FC<MultiStepProps> = ({ sliide }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [startX, setStartX] = useState(0);
  const slides = sliide
    ? [
        images.partnerpluginsdk_be_suresliide_1?.default,
        images.partnerpluginsdk_be_suresliide_2?.default,
        images.partnerpluginsdk_be_suresliide_3?.default,
        images.partnerpluginsdk_be_suresliide_4?.default,
        images.partnerpluginsdk_be_suresliide_5?.default,
      ]
    : [
        images.partnerpluginsdk_be_sure_1?.default,
        images.partnerpluginsdk_be_sure_2?.default,
        images.partnerpluginsdk_be_sure_3?.default,
        images.partnerpluginsdk_be_sure_4?.default,
        images.partnerpluginsdk_be_sure_5?.default,
      ];

  const handleTouchStart = (e: any) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e: any) => {
    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;

    if (deltaX > 50 && activeIndex > 0) {
      setActiveIndex((prev) => prev - 1);
    } else if (deltaX < -50 && activeIndex < slides.length - 1) {
      setActiveIndex((prev) => prev + 1);
    }
  };

  return (
    <Container onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd}>
      <Slides activeIndex={activeIndex}>
        {slides.map((img, index) => (
          <Slide key={index}>
            <StyledImage src={img} alt={`Slide ${index}`} />
          </Slide>
        ))}
      </Slides>
      <PillsContainer>
        {slides.map((_, index) => (
          <Pill
            sliide={sliide}
            key={index}
            active={index === activeIndex}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </PillsContainer>
    </Container>
  );
};

export default BeSureToAllowSlide;
